import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const mm = gsap.matchMedia();

mm.add('(min-width: 1200px)', () => {
  const $iframe = $('.home-hero-iframe');

  if ($iframe.length) {
    gsap.to('.home-hero-iframe', {
      scale: 1.5,
      ease: 'none',
      scrollTrigger: {
        trigger: '.home-hero',
        start: '50% 50%',
        end: '60% 40%',
        scrub: true,
      },
    });
  }
});
